var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chart"},[_c('line-chart',{attrs:{"chart-data":_vm.chartData,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }